import React, { useState } from 'react'
import { AiOutlineArrowDown, AiOutlineArrowRight } from 'react-icons/ai'
import { FiTrash2 } from 'react-icons/fi'
import { HiOutlineDocumentAdd } from 'react-icons/hi'
import ModalConfirm from './ModalConfirm'

/**
 * Componente de Accordion que se encarga de agrupar data perteneciente
 * a una estructura de datos, para facil lectura.
 * @param {string} title se encarga de mostrar el titulo del acordion.
 * @param {any[]} data informacion que se renderizará dentro del acordion,
 * se pasa un array de objetos, (el key y el valor deben de ser descriptivos, ya que
 * eso es lo que se mostrará dentro del acordion.)
 * @param {any[]} accounts array de cuentas, con la finalidad de obtener el id al momento de borrar.
 * @param {Function} deleteHandler  funcion que se llama al dar click al boton de la papelera,
 * para realizar el borrado de la cuenta.
 * @param {boolean} enableDelete flag que se usa para desaparecer la papelera.
 */
const Accordion: React.FC<AccordionProp> = ({
  title,
  data,
  accounts,
  deleteHandler = () => {},
  enableDelete = true,
  addToBillsToPay,
}): JSX.Element => {
  const [isShownData, setIsShownData] = useState<boolean>(false)

  const [accountId, setAccountId] = useState(null)

  const [confirmModal, setConfirmModal] = useState(false)

  const handleConfirm = () => {
    deleteHandler(accountId)
  }

  return (
    <div>
      <div
        className="flex flex-row justify-between mt-8"
        onClick={() => setIsShownData(!isShownData)}
        style={{ cursor: 'pointer' }}
      >
        <div>
          <h2 className="font-bold">{title}</h2>
        </div>
        {isShownData ? <AiOutlineArrowDown /> : <AiOutlineArrowRight />}
      </div>

      <div>
        {isShownData ? (
          <ul>
            {data.map((account, i) => (
              <div key={i}>
                <div className="p-2 flex flex-wrap items-center justify-between bg-gray-100 dark:bg-gray-800 rounded-lg mt-6">
                  <div
                    className="p-4 ml-4"
                    style={{ width: '450px', overflowWrap: 'break-word' }}
                  >
                    {Object.keys(account).map((value, i) => (
                      <li className="block" key={i}>
                        {value}: {account[value]}
                      </li>
                    ))}
                  </div>

                  {enableDelete && (
                    <div className="flex justify-end">
                      <button
                        className="mr-4 mt-4 border-none"
                        onClick={(e) => {
                          e.preventDefault()
                          setConfirmModal(true)
                          setAccountId(accounts[i].id)
                        }}
                      >
                        <FiTrash2 size={20} color="red" />
                      </button>
                    </div>
                  )}

                  {addToBillsToPay && (
                    <div className='flex justify-end'> 
                    <button
                      className="mr-4 mt-4 border-none"
                      onClick={() => addToBillsToPay(account, title, i)}
                    >
                      <HiOutlineDocumentAdd
                        size={30}
                        className="text-green-600 cursor-pointer"
                      />
                    </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </ul>
        ) : null}
      </div>
      <ModalConfirm
        title="¿Deseas eliminar esta cuenta?"
        displayConfirmModal={confirmModal}
        onCancel={() => setConfirmModal(false)}
        onConfirm={handleConfirm}
      />
    </div>
  )
}

interface AccordionProp {
  title: string
  data: any[]
  accounts?: any
  deleteHandler: Function
  enableDelete?: boolean
  addToBillsToPay?: Function
}

export default Accordion
